import { jsxs as l, jsx as C } from "react/jsx-runtime";
function e(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M9.51076 3.99767C9.96025 3.99767 10.5496 4.10754 11.1989 4.95655C13.6761 8.19278 14.3054 11.419 14.2754 13.147C14.2754 13.7962 13.736 14.3057 13.0967 14.3256C13.0268 14.3256 12.9569 14.3256 12.877 14.3256C10.8193 14.3256 7.67283 13.4367 4.99585 10.9496C4.01695 10.0406 4.00697 9.36142 4.00697 9.14167C4.00697 8.23273 4.69619 7.05411 5.96476 5.82554C7.14343 4.68687 8.5019 3.98768 9.52075 3.98768L9.51076 3.99767ZM9.51076 2C7.71279 2 5.86487 3.14866 4.56633 4.39721C2.42874 6.45481 0.530885 9.54121 3.62739 12.4179C6.76386 15.3245 10.3998 16.3233 12.867 16.3233C14.1455 16.3233 15.1244 16.0536 15.5539 15.6441C16.8125 14.4355 16.7027 8.88198 12.7771 3.74796C11.8182 2.48943 10.6695 2 9.50077 2H9.51076Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.7349 14.7352C15.1244 14.3456 15.7038 14.3057 16.0434 14.6453L21.7769 20.3586C21.9467 20.5284 22.0167 20.7382 21.9967 20.9879C21.9767 21.2376 21.8668 21.4673 21.6671 21.6671C21.4673 21.8668 21.2475 21.9767 20.9978 21.9967C20.7481 22.0167 20.5483 21.9467 20.3785 21.7769L14.645 16.0436C14.3054 15.704 14.3453 15.1147 14.7349 14.7352Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21.0977 2.87898C20.5084 2.28966 19.8091 2 18.9801 2C18.151 2 17.4418 2.28966 16.8625 2.87898C16.2731 3.46829 15.9835 4.16747 15.9835 4.99651C15.9835 5.82554 16.2731 6.53471 16.8625 7.11404C17.4518 7.70335 18.151 7.99301 18.9801 7.99301C19.8091 7.99301 20.5184 7.70335 21.0977 7.11404C21.687 6.52472 21.9767 5.82554 21.9767 4.99651C21.9767 4.16747 21.687 3.4583 21.0977 2.87898ZM19.8891 5.90545C19.6393 6.15516 19.3397 6.285 18.9801 6.285C18.6205 6.285 18.3208 6.16514 18.0711 5.90545C17.8214 5.65574 17.6915 5.35609 17.6915 4.99651C17.6915 4.63693 17.8114 4.33728 18.0711 4.08757C18.3208 3.83786 18.6205 3.70801 18.9801 3.70801C19.3397 3.70801 19.6393 3.83786 19.8891 4.08757C20.1388 4.33728 20.2686 4.63693 20.2686 4.99651C20.2686 5.35609 20.1488 5.65574 19.8891 5.90545Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  e as default
};
